import { forwardRef, useEffect } from "react";
import fjGallery from "flickr-justified-gallery";

/*eslint-disable */

declare const window: any;

interface GaleriaVehiculosComponentProps {
  selectedGalery: any;
  setSelectedGalery: any;
  galeria: any;
}

const GaleriaVehiculosComponent = forwardRef<
  HTMLDivElement,
  GaleriaVehiculosComponentProps
>(({ selectedGalery, setSelectedGalery, galeria }, ref) => {
  useEffect(() => {
    fjGallery(document.querySelectorAll(".gallery"), {
      itemSelector: ".gallery__item",
      rowHeight: 180,
      lastRow: "start",
      gutter: 2,
      rowHeightTolerance: 0.1,
      calculateItemsHeight: false,
    });
  }, []);

  return (
    <div className="galeria-vehiculos-detail-component" ref={ref}>
      {/* H2 - Título de la galería */}
      <h2 className="title-galeria-vehiculos-detail-component">Galería</h2>
      <div className="colmena-galeria-vehiculos-detail-component">
        {galeria?.thumbnail?.map((item: any, index: any) => (
          <div
            key={index}
            className={`item-colmena-galeria-vehiculos-detail-component ${
              index === selectedGalery ? "active" : ""
            }`}
            onClick={() =>
              setSelectedGalery(index === selectedGalery ? null : index)
            }
          >
            <img 
              src={`https://manager.hyundaicolombia.co/${item}`} 
              alt={`Imagen ${index + 1} de la galería de vehículos Hyundai`} 
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default GaleriaVehiculosComponent;